import React from 'react';
import { MyActiveCandidates } from '../DashboardHRLead/DashboardHRLead';
import './style.scss';

export const DashboardInterviewer: React.FC = () => (
  <div className="dashboard-interviewer">
    <MyActiveCandidates setTabsLoading={() => {}} />
  </div>
);
